














import Vue from "vue";
export default Vue.extend({
  props: ["title", "description"],
  created() {
    //console.log(this.$attrs);
  }
});
